// extracted by mini-css-extract-plugin
export default {"root":"Lesson_root__RWFDf","name":"Lesson_name__a46s9"};